import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBuyButtonArticleNumber } from '../../Actions/BuyButton.action';
import Dropdown from '../Dropdown';
import VariantPickerOption from './types/VariantPickerOption';
import { translate } from '../../Services/translation';
import VariantPickerProps from './types/VariantPickerProps';

const VariantPickerDropdown = ({
  options,
  selectedValue,
}: VariantPickerProps) => {
  const dispatch = useDispatch();

  const onChange = (option: VariantPickerOption) => {
    dispatch(setBuyButtonArticleNumber(option.value));
  };

  useEffect(() => {
    if (selectedValue) {
      setTimeout(() => dispatch(setBuyButtonArticleNumber(selectedValue)), 1);
    }
  }, [dispatch, selectedValue]);

  return (
    <Dropdown
      placeholder={translate('variant-picker.select-option')}
      options={options}
      onChange={onChange}
      selectedValue={selectedValue}
    />
  );
};

export default VariantPickerDropdown;
